import React from "react";
import { useMsal } from "@azure/msal-react";
import { Typography } from "@mui/material";

export default function Logout() {
  const { instance } = useMsal();
  const handleLogout = () => {
    instance.logoutRedirect();
  };
  
  return (
    <Typography variant="h4" color="black_solid.80" onClick={handleLogout}>
      Logout
    </Typography>
  );
}